module.exports = __webpack_public_path__ + "h5/img/bg_upload_by_link_3.6dc34a3a.6dc34a3a.png";